unit share.classes;

interface

uses
  System.Generics.Collections;

type
  TUserAccess = class
  private
    FAutono : Integer;
    FMainCat : String;
    FSubCat : String;
    FData : Boolean;
  public
    property Autono : Integer read FAutono write FAutono;
    property MainCat : String read FMainCat write FMainCat;
    property SubCat : String read FSubCat write FSubCat;
    property Data : Boolean read FData write FData;
  end;

  TUser = class
  private
    FCode: String;
    FName: String;
    FEmail: String;
    FPassw: String;
    FEmailPass : String;
    FSiteCode : Integer;
    FMailClient : Integer;
    FCellNumber : String;
  published
    property Code: String read FCode write FCode;
    property Name: String read FName write FName;
    property Email: String read FEmail write FEmail;
    property Passw: String read FPassw write FPassw;
    property EmailPass : String read FEmailPass write FEmailPass;
    property SiteCode : Integer read FSiteCode write FSiteCode;
    property MailClient : Integer read FMailClient write FMailClient;
    property CellNumber : String read FCellNumber write FCellNumber;
  End;

  TLogin = class
  private
    FToken : String;
    FWrongPassword : Boolean;
    FWrongUser : Boolean;
    FUserNo : Integer;
  published
    property Token : String read FToken write FToken;
    property WrongPassword : Boolean read FWrongPassword write FWrongPassword;
    property WrongUser : Boolean read FWrongUser write FWrongUser;
    property UserNo : Integer read FUserNo write FUserNo;
  public
    destructor Destroy; override;
  end;

  TSubsFleetSummary = class
  private
    FRegNo : String;
    FRevenu : Currency;
    FRevTons : Real;
    FRevKilos : Integer;
    FDieselCost : Currency;
    FDieselLitres : Real;
    FDieselKilos : Integer;
    FDieselConsump : Real;
    FDieselPerc : Real;
    FSurplus : Currency;
    FSurplusPerc : Real;
    FLoadMass : Real;
    FOffMass : Real;
  published
    property RegNo : String read FRegNo write FRegNo;
    property Revenu : Currency read FRevenu write FRevenu;
    property RevTons : Real read FRevTons write FRevTons;
    property RevKilos : Integer read FRevKilos write FRevKilos;
    property DieselCost : Currency read FDieselCost write FDieselCost;
    property DieselLitres : Real read FDieselLitres write FDieselLitres;
    property DieselKilos : Integer read FDieselKilos write FDieselKilos;
    property DieselConsump : Real read FDieselConsump write FDieselConsump;
    property DieselPerc : Real read FDieselPerc write FDieselPerc;
    property Surplus : Currency read FSurplus write FSurplus;
    property SurplusPerc : Real read FSurplusPerc write FSurplusPerc;
    property LoadMass : Real read FLoadMass write FLoadMass;
    property OffMass : Real read FOffMass write FOffMass;
  public
    destructor Destroy; override;
  end;

  TSubsFleetLoadDetails = class
  private
    FLoadConNo : Integer;
    FRegNo : String;
    FEmpCode : String;
    FEmpName : String;
    FRoute : String;
    FLoadingDate : String;
    FOffLoadingDate : String;
    FTons : Real;
    FRate : Real;
    FRevenue : Currency;
    FTotalTravelTime : String;
    FLoadingTime : String;
    FOffLoadingTime : String;
    FTravelTime : String;
    FLoadStartKilos : Integer;
    FStartKilos : Integer;
    FEndKilos : Integer;
    FClientInvNo : String;
    FSubsInvNo : String;
    FDocketNo : String;
    FInvoiceType : String;
    FLoadMass : Real;
    FOffMass : Real;
    FLoadGross : Real;
    FOffGross : Real;

  published
    property LoadConNo : Integer read FLoadConNo write FLoadConNo;
    property RegNo : String read FRegNo write FRegNo;
    property EmpCode : String read FEmpCode write FEmpCode;
    property EmpName : String read FEmpName write FEmpName;
    property Route : String read FRoute write FRoute;
    property LoadingDate : String read FLoadingDate write FLoadingDate;
    property OffLoadingDate : String read FOffLoadingDate write FOffLoadingDate;
    property Tons : Real read FTons write FTons;
    property Rate : Real read FRate write FRate;
    property Revenue : Currency read FRevenue write FRevenue;
    property TotalTravelTime : String read FTotalTravelTime write FTotalTravelTime;
    property LoadingTime : String read FLoadingTime write FLoadingTime;
    property OffLoadingTime : String read FOffLoadingTime write FOffLoadingTime;
    property TravelTime : String read FTravelTime write FTravelTime;
    property LoadStartKilos : Integer read FLoadStartKilos write FLoadStartKilos;
    property StartKilos : Integer read FStartKilos write FStartKilos;
    property EndKilos : Integer read FEndKilos write FEndKilos;
    property ClientInvNo : String read FClientInvNo write FClientInvNo;
    property SubsInvNo : String read FSubsInvNo write FSubsInvNo;
    property DocketNo : String read FDocketNo write FDocketNo;
    property InvoiceType : String read FInvoiceType write FInvoiceType;
    property LoadMass : real read FLoadMass write FLoadMass;
    property OffMass : real read FOffMass write FOffMass;
    property LoadGross : real read FLoadGross write FLoadGross;
    property OffGross : real read FOffGross write FOffGross;

  public
    destructor Destroy; override;
  end;

  TSubsFleetDieselDetails = class
  private
    FOrderNo : Integer;
    FRegNo : String;
    FOrderDate : String;
    FLitres : Real;
    FPrice : Real;
    FAmount : Real;
    FStartKilos : Integer;
    FEndKilos : Integer;
    FTotalKilos : Integer;
    FFullFill : Boolean;
    FFuelConsumption : Real;
    FDepotName : String;
    FEmpCode : String;
    FEmpName : String;
  published
    property OrderNo : Integer read FOrderNo write FOrderNo;
    property RegNo : String read FRegNo write FRegNo;
    property OrderDate : String read FOrderDate write FOrderDate;
    property Litres : Real read FLitres write FLitres;
    property Price : Real read FPrice write FPrice;
    property Amount : Real read FAmount write FAmount;
    property StartKilos : Integer read FStartKilos write FStartKilos;
    property EndKilos : Integer read FEndKilos write FEndKilos;
    property TotalKilos : Integer read FTotalKilos write FTotalKilos;
    property FullFill : Boolean read FFullFill write FFullFill;
    property FuelConsumption : Real read FFuelConsumption write FFuelConsumption;
    property DepotName : String read FDepotName write FDepotName;
    property EmpCode : String read FEmpCode write FEmpCode;
    property EmpName : String read FEmpName write FEmpName;
  public
    destructor Destroy; override;
  end;

  TDriverFleetLoads = class
    private
      FPlanNo : Integer;
      FLoadConNo : Integer;
      FLoadDate : TDateTime;
      FDesc : String;
      FDriverLoaded : Boolean;
      FDriverOffLoaded : Boolean;
    published
      property PlanNo : Integer read FPlanNo write FPlanNo;
      property LoadConNo : Integer read FLoadConNo write FLoadConNo;
      property LoadDate : TDateTime read FLoadDate write FLoadDate;
      property Desc : String read FDesc write FDesc;
      property DriverLoaded : Boolean read FDriverLoaded write FDriverLoaded;
      property DriverOffLoaded : Boolean read FDriverOffLoaded write FDriverOffLoaded;
    public
      destructor Destroy; override;
  end;

  TRepGetLoadDetails = class
    private
      FAccount : String;
      FStartDate : TDate;
      FEndDate : TDate;
      FRegNo : String;
      FReportType : String;
      FDateType : Word;
    published
      property Account : String read FAccount write FAccount;
      property StartDate : TDate read FStartDate write FStartDate;
      property EndDate : TDate read FEndDate write FEndDate;
      property RegNo : String read FRegNo write FRegNo;
      property ReportType : String read FReportType write FReportType;
      property DateType : word read FDateType write FDateType;
  end;

  TDirectDownload = class
    private
      FFilename : String;
      FData : String;
      FContentType : String;
    published
      property Filename : String read FFilename write FFilename;
      property Data : string read FData write FData;
      property ContentType : string read FContentType write FContentType;
  end;

  TFileInfo = class
    private
      FName : String;
      FFileType : String;
      FDocket : Boolean;
      FWaybill : Boolean;
      FFileStream : String;
    public
      property Name : String read FName write FName;
      property FileType : String read FFileType write FFileType;
      property Docket : Boolean read FDocket write FDocket;
      property Waybill : Boolean read FWaybill write FWaybill;
      property FileStream : String read FFileStream write FFileStream;
  end;

  TLoadingFile = class
    private
      FNo : Integer;
      FLoadconNo : Integer;
      FArivalDate : TDate;
      FArivalTime : TTime;
      FDepartureDate : TDate;
      FDepartureTime : TTime;
      FKilos : Integer;
      FTare : Real;
      FGross : Real;
      FMass : Real;
      FDocketNo : String;
      FWaybill : String;
      FFileInfo : TList<TFileInfo>;
    public
      property No : Integer read FNo write FNo;
      property LoadconNo : Integer read FLoadconNo write FLoadconNo;
      property ArivalDate : TDate read FArivalDate write FArivalDate;
      property ArivalTime : TTime read FArivalTime write FArivalTime;
      property DepartureDate : TDate read FDepartureDate write FDepartureDate;
      property DepartureTime : TTime read FDepartureTime write FDepartureTime;
      property Kilos : Integer read FKilos write FKilos;
      property Tare : Real read FTare write FTare;
      property Gross : Real read FGross write FGross;
      property Mass : Real read FMass write FMass;
      property DocketNo : String read FDocketNo write FDocketNo;
      property Waybill : String read FWaybill write FWaybill;
      property FileInfo : TList<TFileInfo> read FFileInfo write FFileInfo;
  end;

  TBooleanResult = class
    private
      FReturnResult : Boolean;
    public
      property ReturnResult : Boolean read FReturnResult write FReturnResult;
  end;

  TTrailer = class
    private
      FRegNo : String;
      FPos : Integer;
    public
      property RegNo : string read FRegNo write FRegNo;
      property Pos : integer read FPos write FPos;
  end;

  TCreateLoadcon = class
    private
      FAccount : String;
      FSub : String;
      FRegNo : string;
      FResource : Integer;
      FContract : Integer;
      FLoadDate : TDate;
      FOffLoadDate : TDate;
      FNo : Integer;
      FSubRate : Real;
      FClientRate : Real;
      FDocketNo : string;
      FLoadWayBill : String;
      FTare : Real;
      FGross : Real;
      FMass : Real;
      FArrival : TDateTime;
      FDeparture : TDateTime;
      FKilos : Integer;
      FTrailer : TList<TTrailer>;
    public
      property Account : String read FAccount write FAccount;
      property Sub : String read FSub write FSub;
      property RegNo : string read FRegNo write FRegNo;
      property Resource : Integer read FResource write FResource;
      property Contract : Integer read FContract write FContract;
      property LoadDate : TDate read FLoadDate write FLoadDate;
      property OffLoadDate : TDate read FOffLoadDate write FOffLoadDate;
      property No : Integer read FNo write FNo;
      property SubRate : Real read FSubRate write FSubRate;
      property ClientRate : Real read FClientRate write FClientRate;
      property DocketNo : string read FDocketNo write FDocketNo;
      property LoadWayBill : String read FLoadWayBill write FLoadWayBill;
      property Tare : Real read FTare write FTare;
      property Gross : Real read FGross write FGross;
      property Mass : Real read FMass write FMass;
      property Arrival : TDateTime read FArrival write FArrival;
      property Departure : TDateTime read FDeparture write FDeparture;
      property Kilos : Integer read FKilos write FKilos;
      property Trailer : TList<TTrailer> read FTrailer write FTrailer;
  end;

  TGetLoadCon = class
    private
      FLoadConNo : Integer;
      FLinkNo : Integer;
      FLoadTare : Real;
      FLoadGross : Real;
      FKilos : Integer;
      FLoadDateST : TDateTime;
      FLoadDateET : TDateTime;
    public
      property LoadConNo : Integer read FLoadConNo write FLoadConNo;
      property LinkNo : Integer read FLinkNo write FLinkNo;
      property LoadTare : Real read FLoadTare write FLoadTare;
      property LoadGross : Real read FLoadGross write FLoadGross;
      property Kilos : Integer read FKilos write FKilos;
      property LoadDateST : TDateTime read FLoadDateST write FLoadDateSt;
      property LoadDateET : TDateTime read FLoadDateET write FLoadDateET;
  end;

  TLoadConNommers = class
    private
      FLoadConNo : Integer;
    public
      property LoadConNo : Integer read FLoadConNo write FLoadConNo;
  end;

  TUpdateRegs = class
    private
      Fno : String;
      Fsubsno : String;
      Fregno : String;
      Ferror : String;
    published
      property no : String read Fno write Fno;
      property subsno : String read Fsubsno write Fsubsno;
      property regno : String read Fregno write Fregno;
      property error : string read Ferror write Ferror;
  end;

  TGetLoads = class
    private
      Fno : Integer;
      Fregno : String;
      Fsubsname : String;
      Fday1 : string;
      Fday2 : string;
      Fday3 : string;
      Fday4 : string;
      Fday5 : string;
      Fday6 : string;
      Fday7 : string;
      Fday8 : string;
      Fday9 : string;
      Fday10 : string;
      Fday11 : string;
      Fday12 : string;
      Fday13 : string;
      Fday14 : string;
      Fday15 : string;
      Fday16 : string;
      Fday17 : string;
      Fday18 : string;
      Fday19 : string;
      Fday20 : string;
      Fday21 : string;
      Fday22 : string;
      Fday23 : string;
      Fday24 : string;
      Fday25 : string;
      Fday26 : string;
      Fday27 : string;
      Fday28 : string;
      Fday29 : string;
      Fday30 : string;
      Fday31 : string;
    published
      property no : Integer read Fno write Fno;
      property regno : String read Fregno write Fregno;
      property subsname : string read Fsubsname write Fsubsname;
      property day1 : string read Fday1 write Fday1;
      property day2 : string read Fday2 write Fday2;
      property day3 : string read Fday3 write Fday3;
      property day4 : string read Fday4 write Fday4;
      property day5 : string read Fday5 write Fday5;
      property day6 : string read Fday6 write Fday6;
      property day7 : string read Fday7 write Fday7;
      property day8 : string read Fday8 write Fday8;
      property day9 : string read Fday9 write Fday9;
      property day10 : string read Fday10 write Fday10;
      property day11 : string read Fday11 write Fday11;
      property day12 : string read Fday12 write Fday12;
      property day13 : string read Fday13 write Fday13;
      property day14 : string read Fday14 write Fday14;
      property day15 : string read Fday15 write Fday15;
      property day16 : string read Fday16 write Fday16;
      property day17 : string read Fday17 write Fday17;
      property day18 : string read Fday18 write Fday18;
      property day19 : string read Fday19 write Fday19;
      property day20 : string read Fday20 write Fday20;
      property day21 : string read Fday21 write Fday21;
      property day22 : string read Fday22 write Fday22;
      property day23 : string read Fday23 write Fday23;
      property day24 : string read Fday24 write Fday24;
      property day25 : string read Fday25 write Fday25;
      property day26 : string read Fday26 write Fday26;
      property day27 : string read Fday27 write Fday27;
      property day28 : string read Fday28 write Fday28;
      property day29 : string read Fday29 write Fday29;
      property day30 : string read Fday30 write Fday30;
      property day31 : string read Fday31 write Fday31;
  end;

  TDieselOrder = class
    private
      FOrderNo : Integer;
      FOrderDate : TDate;
      FRegNo : String;
      FDepotCode : Integer;
      FDepotName : String;
      FSubCode : String;
      FSubName : String;
      FFleetNo : String;
      FOrderLiters : Real;
      FOrderPrice : Real;
      FOrderAmount : Real;
      FInvoicedLiters : Real;
      FCanceled : Boolean;
      FCInvoiced : Boolean;
      FSInvoiced : Boolean;
      FSupplierCode : String;
      FSupplierName : String;
      FSOrderNo : String;
      FSInvoiceNo : String;
      FFillType : Boolean;
      FInProgress : Boolean;
    public
      property OrderNo : Integer read FOrderNo write FOrderNo;
      property OrderDate : TDate read FOrderDate write FOrderDate;
      property RegNo : String read FRegNo write FRegNo;
      property DepotCode : Integer read FDepotCode write FDepotCode;
      property DepotName : String read FDepotName write FDepotName;
      property SubCode : String read FSubCode write FSubCode;
      property SubName : String read FSubName write FSubName;
      property FleetNo : String read FFleetNo write FFleetNo;
      property OrderLiters : Real read FOrderLiters write FOrderLiters;
      property OrderPrice : Real read FOrderPrice write FOrderPrice;
      property OrderAmount : Real read FOrderAmount write FOrderAmount;
      property InvoicedLiters : Real read FInvoicedLiters write FInvoicedLiters;
      property Canceled : Boolean read FCanceled write FCanceled;
      property CInvoiced : Boolean read FCInvoiced write FCInvoiced;
      property SInvoiced : Boolean read FSInvoiced write FSInvoiced;
      property SupplierCode : String read FSupplierCode write FSupplierCode;
      property SupplierName : String read FSupplierName write FSupplierName;
      property SOrderNo : String read FSOrderNo write FSOrderNo;
      property SInvoiceNo : String read FSInvoiceNo write FSInvoiceNo;
      property FillType : Boolean read FFillType write FFillType;
      property InProgress : Boolean read FInProgress write FInProgress;
  end;

  TPlanning = Class
    private
      FNo : Integer;
      FRegSource : Integer;
      FRegNo : String;
      FContractNo : Integer;
      FContractName : String;
      FSubCode : String;
      FSubName : String;
      FCanceled : Boolean;
      FLoaded : Boolean;
      FOffLoaded : Boolean;
      FLoadingDate : String;
      FOffLoadingDate : String;
      FLoadconno : Integer;
      FCInvoiceNo : String;
      FCInvoiced : Boolean;
      FSInvoiceNo : String;
      FSInvoiced : Boolean;
      FLoadStandTime : TTime;
      FOffLoadStandTime : TTime;
      FTrafelTime : TTime;
      FTimeLeft : TTime;
      FSystemType : String;

    public
      property No               : Integer   read FNo               write FNo;
      property RegSource        : Integer   read FRegSource        write FRegSource;
      property RegNo            : String    read FRegNo            write FRegNo;
      property ContractNo       : Integer   read FContractNo       write FContractNo;
      property ContractName     : String    read FContractName     write FContractName;
      property SubCode          : String    read FSubCode          write FSubCode;
      property SubName          : String    read FSubName          write FSubName;
      property Canceled         : Boolean   read FCanceled         write FCanceled;
      property Loaded           : Boolean   read FLoaded           write FLoaded;
      property OffLoaded        : Boolean   read FOffLoaded        write FOffLoaded;
      property LoadingDate      : String    read FLoadingDate      write FLoadingDate;
      property OffLoadingDate   : String    read FOffLoadingDate   write FOffLoadingDate;
      property Loadconno        : Integer   read FLoadconno        write FLoadconno;
      property CInvoiceNo       : String    read FCInvoiceNo       write FCInvoiceNo;
      property CInvoiced        : Boolean   read FCInvoiced        write FCInvoiced;
      property SInvoiceNo       : String    read FSInvoiceNo       write FSInvoiceNo;
      property SInvoiced        : Boolean   read FSInvoiced        write FSInvoiced;
      property LoadStandTime    : TTime     read FLoadStandTime    write FLoadStandTime;
      property OffLoadStandTime : TTime     read FOffLoadStandTime write FOffLoadStandTime;
      property TrafelTime       : TTime     read FTrafelTime       write FTrafelTime;
      property TimeLeft         : TTime     read FTimeLeft         write FTimeLeft;
      property SystemType       : String    read FSystemType       write FSystemType;

  End;

  TPlanResources = class
    private
      FNo : Integer;
      FRegNo : String;
    public
      property No               : Integer   read FNo               write FNo;
      property RegNo            : String    read FRegNo            write FRegNo;
  end;

  TPlanDashBoard = class
    private
      FNo : Integer;
      FSubCode : String;
      FSubName : String;
      FGroupNo : Integer;
      FGroupName : String;
      FRegNo : String;
      FLoadsNotStarted : Integer;
      FLoadsStarted : Integer;
      FLoadEndTime : String;
      FCurrentTime : String;
      FTotalHours : Integer;
      FTimeLeft : String;
      FFirstwarning : Integer;
      FSecondwarning : Integer;
      FKilos : Integer;
      FLastKilosService : Integer;
      FKilosNextService : Integer;
      FDieselOrder : Integer;
      FWarnings : Integer;
      FLastLoadStart : String;
      FLastLoadPlan : String;
      FLastDieselOrder : String;
      FRevenu : Real;
      FSurplus : Real;
      FSurplusPerc : Real;
      FDayAverage : Real;
      FDayGood : Real;
      FDayFirst : Real;
      FDaySecond : Real;
      FRevToDate : Real;
      FSurplusToDate : Real;
      FStartKilos : Integer;
      FEndKilos : Integer;
      FFuelConsumption : Real;
      FOrderLiters : Real;
      FInvoiceLiters : Real;
      FLoadCount : Integer;
      FFleetNo : String;
      FAvgGross : Real;
    public
      property No               : Integer   read FNo               write FNo;
      property SubCode          : String    read FSubCode          write FSubCode;
      property SubName          : String    read FSubName          write FSubName;
      property GroupNo          : Integer   read FGroupNo          write FGroupNo;
      property GroupName        : String    read FGroupName        write FGroupName;
      property RegNo            : String    read FRegNo            write FRegNo;
      property LoadsNotStarted  : Integer   read FLoadsNotStarted  write FLoadsNotStarted;
      property LoadsStarted     : Integer   read FLoadsStarted     write FLoadsStarted;
      property LoadEndTime      : String    read FLoadEndTime      write FLoadEndTime;
      property CurrentTime      : String    read FCurrentTime      write FCurrentTime;
      property TotalHours       : Integer   read FTotalHours       write FTotalHours;
      property TimeLeft         : String    read FTimeLeft         write FTimeLeft;
      property Firstwarning     : Integer   read FFirstwarning     write FFirstwarning;
      property Secondwarning    : Integer   read FSecondwarning    write FSecondwarning;
      property Kilos            : Integer   read FKilos            write FKilos;
      property LastKilosService : Integer   read FLastKilosService write FLastKilosService;
      property KilosNextService : Integer   read FKilosNextService write FKilosNextService;
      property DieselOrder      : Integer   read FDieselOrder      write FDieselOrder;
      property Warnings         : Integer   read FWarnings         write FWarnings;
      property LastLoadStart    : String    read FLastLoadStart    write FLastLoadStart;
      property LastLoadPlan     : String    read FLastLoadPlan     write FLastLoadPlan;
      property LastDieselOrder  : String    read FLastDieselOrder  write FLastDieselOrder;
      property Revenu           : Real      read FRevenu           write FRevenu;
      property Surplus          : Real      read FSurplus          write FSurplus;
      property SurplusPerc      : Real      read FSurplusPerc      write FSurplusPerc;
      property DayAverage       : Real      read FDayAverage       write FDayAverage;
      property DayGood          : Real      read FDayGood          write FDayGood;
      property DayFirst         : Real      read FDayFirst         write FDayFirst;
      property DaySecond        : Real      read FDaySecond        write FDaySecond;
      property RevToDate        : Real      read FRevToDate        write FRevToDate;
      property SurplusToDate    : Real      read FSurplusToDate    write FSurplusToDate;
      property StartKilos       : Integer   read FStartKilos       write FStartKilos;
      property EndKilos         : Integer   read FEndKilos         write FEndKilos;
      property FuelConsumption  : Real      read FFuelConsumption  write FFuelConsumption;
      property OrderLiters      : Real      read FOrderLiters      write FOrderLiters;
      property InvoiceLiters    : Real      read FInvoiceLiters    write FInvoiceLiters;
      property LoadCount        : Integer   read FLoadCount        write FLoadCount;
      property FleetNo          : String    read FFleetNo          write FFleetNo;
      property AvgGross         : Real      read FAvgGross         write FAvgGross;
  end;

  TPlanDashBoardGS = class
    private
      FGroupNo : Integer;
      FGroupName : String;
      FLoadsNotStarted : Integer;
      FLoadsStarted : Integer;
      FFirstwarning : Integer;
      FSecondwarning : Integer;
      FKilos : Integer;
      FWarnings : Integer;
      FRevenu : Real;
      FSurplus : Real;
      FSurplusPerc : Real;
      FDayAverage : Real;
      FDayGood : Real;
      FDayFirst : Real;
      FDaySecond : Real;
      FRevToDate : Real;
      FSurplusToDate : Real;
      FFuelConsumption : Real;
      FOrderLiters : Real;
      FInvoiceLiters : Real;
      FLoadCount : Integer;
    public
      property GroupNo          : Integer   read FGroupNo          write FGroupNo;
      property GroupName        : String    read FGroupName        write FGroupName;
      property LoadsNotStarted  : Integer   read FLoadsNotStarted  write FLoadsNotStarted;
      property LoadsStarted     : Integer   read FLoadsStarted     write FLoadsStarted;
      property Firstwarning     : Integer   read FFirstwarning     write FFirstwarning;
      property Secondwarning    : Integer   read FSecondwarning    write FSecondwarning;
      property Kilos            : Integer   read FKilos            write FKilos;
      property Warnings         : Integer   read FWarnings         write FWarnings;
      property Revenu           : Real      read FRevenu           write FRevenu;
      property Surplus          : Real      read FSurplus          write FSurplus;
      property SurplusPerc      : Real      read FSurplusPerc      write FSurplusPerc;
      property DayAverage       : Real      read FDayAverage       write FDayAverage;
      property DayGood          : Real      read FDayGood          write FDayGood;
      property DayFirst         : Real      read FDayFirst         write FDayFirst;
      property DaySecond        : Real      read FDaySecond        write FDaySecond;
      property RevToDate        : Real      read FRevToDate        write FRevToDate;
      property SurplusToDate    : Real      read FSurplusToDate    write FSurplusToDate;
      property FuelConsumption  : Real      read FFuelConsumption  write FFuelConsumption;
      property OrderLiters      : Real      read FOrderLiters      write FOrderLiters;
      property InvoiceLiters    : Real      read FInvoiceLiters    write FInvoiceLiters;
      property LoadCount        : Integer   read FLoadCount        write FLoadCount;
  end;

  TSubsCompanies = class
    private
      FSubCode : String;
      FSubName : String;
      FDieselBalance : Real;
    public
      property SubCode          : String    read FSubCode     write FSubCode;
      property SubName          : String    read FSubName     write FSubName;
      property DieselBalance    : Real    read FDieselBalance write FDieselBalance;
  end;

  TFuelDepots = class
    private
      FDepotCode : Integer;
      FDepotName : String;
    public
      property DepotCode  : Integer read FDepotCode write FDepotCode;
      property DepotName  : String  read FDepotName write FDepotName;
  end;

  TSubsReg = class
    private
      FRegNo : String;
      FFleetNo : String;
      FFuelTank : Integer;
    public
      property RegNo : String read FRegNo write FRegNo;
      property FleetNo : String read FFleetNo write FFleetNo;
      property FuelTank : Integer read FFuelTank write FFuelTank;
  end;

  TOpenDieselOrders = class
    private
      FOrderNo : Integer;
      FRegNo : String;
      FOrderDate : TDate;
      FLitres : Real;
      FDepotCode : Integer;
      FDepotName : String;
      FPrice : Real;
      FAmount : Real;
      FFullFill : Boolean;
      FSubCode : String;
      FSubName : String;
      FDieselOrder : Integer;
      FCompleted : String;
    public
      property OrderNo : Integer read FOrderNo write FOrderNo;
      property RegNo : String read FRegNo write FRegNo;
      property OrderDate : TDate read FOrderDate write FOrderDate;
      property Litres : Real read FLitres write FLitres;
      property DepotCode : Integer read FDepotCode write FDepotCode;
      property DepotName : String read FDepotName write FDepotName;
      property Price : Real read FPrice write FPrice;
      property Amount : Real read FAmount write FAmount;
      property FullFill : Boolean read FFullFill write FFullFill;
      property SubCode : String read FSubCode write FSubCode;
      property SubName : String read FSubName write FSubName;
      property DieselOrder : Integer read FDieselOrder write FDieselOrder;
      property Completed : String read FCompleted write FCompleted;
  end;

  TSearchSubs = class
    private
      FSubCode : String;
      FSubName : String;
      FSuspended : Boolean;
      FSubType : Integer;
      FTypeName : String;
    public
      property SubCode : String read FSubCode write FSubCode;
      property SubName : String read FSubName write FSubName;
      property Suspended : Boolean read FSuspended write FSuspended;
      property SubType : Integer read FSubType write FSubType;
      property TypeName : String read FTypeName write FTypeName;
  end;

  TSearchGroup = class
    private
      FGroupNo : Integer;
      FGroupName : String;
      FSuspended : Boolean;
    public
      property GroupNo : Integer read FGroupNo write FGroupNo;
      property GroupName : String read FGroupName write FGroupName;
      property Suspended : Boolean read FSuspended write FSuspended;
  end;

  TSearchReg = class
    private
      FRegNo : String;
      FSubCode : String;
      FFleetNo : String;
      FSubName : String;
      FGroup : Integer;
      FGroupName : String;
      FCategory : Integer;
      FCategoryName : String;
      FSuspended : Boolean;
      FCostGroup : Integer;
      FCostName : String;
    public
      property RegNo : String read FRegNo write FRegNo;
      property SubCode : String read FSubCode write FSubCode;
      property FleetNo : String read FFleetNo write FFleetNo;
      property SubName : String read FSubName write FSubName;
      property Group : Integer read FGroup write FGroup;
      property GroupName : String read FGroupName write FGroupName;
      property Category : Integer read FCategory write FCategory;
      property CategoryName : String read FCategoryName write FCategoryName;
      property Suspended : Boolean read FSuspended write FSuspended;
      property CostGroup : Integer read FCostGroup write FCostGroup;
      property CostName : String read FCostName write FCostName;
  end;

  TSearchController = class
    private
      FNo : String;
      FName : String;
      FSuspended : Boolean;
    public
      property No : String read FNo write FNo;
      property Name : String read FName write FName;
      property Suspended : Boolean read FSuspended write FSuspended;
  end;

  TSearchDieselDepots = class
    private
      FNo : Integer;
      FName : String;
      FSuspended : Boolean;
    public
      property No : Integer read FNo write FNo;
      property Name : String read FName write FName;
      property Suspended : Boolean read FSuspended write FSuspended;
  end;

  TPlanDashBoardTotals = class
    private
      FCount : Integer;
      FRevenue : Real;
      FSurplus : Real;
      FDayAverage : Real;
      FFuel : Real;
    public
      property Count : Integer read FCount write FCount;
      property Revenue : Real read FRevenue write FRevenue;
      property Surplus : Real read FSurplus write FSurplus;
      property DayAverage : Real read FDayAverage write FDayAverage;
      property Fuel : Real read FFuel write FFuel;
  end;

  TNewDieselOrder = class
    private
      FCompNo : String;
      FRegNo : String;
      FOrderDate : TDate;
      FDepotNo : Integer;
      FLiters : Real;
      FDepotPrice : Real;
      FFillType : Integer;
      FUser : String;
      FDriver : String;
      FSystemType : Integer;
      FNumber : String;
    public
      property CompNo : String read FCompNo write FCompNo;
      property RegNo : String read FRegNo write FRegNo;
      property OrderDate : TDate read FOrderDate write FOrderDate;
      property DepotNo : Integer read FDepotNo write FDepotNo;
      property Liters : Real read FLiters write FLiters;
      property DepotPrice : Real read FDepotPrice write FDepotPrice;
      property FillType : Integer read FFillType write FFillType;
      property User : String read FUser write FUser;
      property Driver : String read FDriver write FDriver;
      property SystemType : Integer read FSystemType write FSystemType;
      property Number : String read FNumber write FNumber;
  end;

  TUpdateDieselOrder = class
    private
      FOrderNo : Integer;
      FCompNo : String;
      FRegNo : String;
      FOrderDate : TDate;
      FDepotNo : Integer;
      FLiters : Real;
      FFillType : Integer;
      FUser : String;
      FDriver : String;
      FSystemType : Integer;
    public
      property OrderNo : Integer read FOrderNo write FOrderNo;
      property CompNo : String read FCompNo write FCompNo;
      property RegNo : String read FRegNo write FRegNo;
      property OrderDate : TDate read FOrderDate write FOrderDate;
      property DepotNo : Integer read FDepotNo write FDepotNo;
      property Liters : Real read FLiters write FLiters;
      property FillType : Integer read FFillType write FFillType;
      property User : String read FUser write FUser;
      property Driver : String read FDriver write FDriver;
      property SystemType : Integer read FSystemType write FSystemType;
  end;

  TDieselOrderStatus = class
    private
      FOrderNo : Integer;
      FValid : Boolean;
      FSystemMessage : String;
    public
      property OrderNo : Integer read FOrderNo write FOrderNo;
      property Valid : Boolean read FValid write FValid;
      property SystemMessage : String read FSystemMessage write FSystemMessage;
  end;

  TAccess = class
    private
      FUsers: Boolean;
      FDieselSystem: Boolean;
      FDieselOrder: Boolean;
      FDieselInv: Boolean;
      FDieselDepots: Boolean;
      FDieselPrice: Boolean;
      FDieselPriceC: Boolean;
      FSubContractors: Boolean;
      FDieselReports: Boolean;
      FDriversys: Boolean;
      FVehicleSys: Boolean;
      FHSEReports: Boolean;
      FOpsReports: Boolean;
      FDieselPay: Boolean;
      Floadconsystem : Boolean;
      FWashbay : Boolean;
      FFullLoadCon : Boolean;
      FLoadConInvoice : Boolean;
      FDrivers : Boolean;
      FDriverReports : Boolean;
      FPublicholidays : Boolean;
      FDriverHours : Boolean;
      FValidateHours : Boolean;
      FConfirmHours : Boolean;
      FClientActive : Boolean;
      FContracts : Boolean;
      FLoadNonC : Boolean;
      FLoadC : Boolean;
      FCancelLoad : Boolean;
      FClient : Boolean;
      FCreateClient : Boolean;
      FSystemSetup : Boolean;
      FControllFinPeriods : Boolean;
      FFineSystem : Boolean;
      FMaintenanceSystem : Boolean;
      FNonConformance : Boolean;
      FVehicleMain : Boolean;
      FDailychecklist : Boolean;
      FAxleMassConfig : Boolean;
      FVehicleunitconfig : Boolean;
      FCombinationconfig : Boolean;
      FVehicleReports : Boolean;
      FVehiclejobcards : Boolean;
      FEmpYearsWeekDays : Boolean;
      FOverspeedingSystem : Boolean;
      FEmpCounselling : Boolean;
      FEmpWarnings : Boolean;
      FEmpBriefing : Boolean;
      FEmpPPE : Boolean;
      FLoadcons : Boolean;
      FLCCreditNoteSystem : Boolean;
      FLCAllocateInv : Boolean;
      FLCPaymentSystem : Boolean;
      FLCReports : Boolean;
      FLCUpdateInvLoads : Boolean;
      FClientPayReceive : Boolean;
      FClientUnAllPay : Boolean;
      FClientsites : Boolean;
      FClientWrietOff : Boolean;
      FSubRemittance : Boolean;
      FSubPayment : Boolean;
      FSubUnAllPay : Boolean;
      FSubAllPay : Boolean;
      FSubWriteOff : Boolean;
      FLCSLCN : Boolean;
      FLCMLCN : Boolean;
      FFuelAttendants : Boolean;
      FFuelDepots : Boolean;
      FFuelControlSheets : Boolean;
      FFuelMonthEnd : Boolean;
      FFuelCDN : Boolean;
      FFuelUpdateInv : Boolean;
      FFuelTankSetup : Boolean;
      FFuelPriceChange : Boolean;
      FFuelSuspendDepots : Boolean;
      FVehcategories : Boolean;
      FVehservicetypes : Boolean;
      FVehservicehistory : Boolean;
      FVehMoveHistory : Boolean;
      FCompsites : Boolean;
      FAutoEmail : Boolean;
      FRegAccess : Boolean;
      Fpastelexport : Boolean;
      FInvoiceLitres : Boolean;
      FExportToExcel : Boolean;
      FRemContPrice : Boolean;
      FOpenContPrice : Boolean;
      FRemDieselPrice : Boolean;
      FOpenDieselPrice : Boolean;
      FWarehouse : Boolean;
      FLocations : Boolean;
      FCategories : Boolean;
      FWaranties : Boolean;
      FStockInfo : Boolean;
      FStkSuppliers : Boolean;
      FJCstock : Boolean;
      FJCTyres : Boolean;
      FPRstock : Boolean;
      FPRTyres : Boolean;
      FPOstock : Boolean;
      FPOTyres : Boolean;
      FPOAstock : Boolean;
      FPOATyres : Boolean;
      FPDstock : Boolean;
      FPDTyres : Boolean;
      FSuppInv : Boolean;
      FStockTake : Boolean;
      FStocktransfer : Boolean;
      FStockRep : Boolean;
      FCaptureMultiLoads : Boolean;
      FLoadSupervisor : Boolean;
      FDieselSupervisor : Boolean;
      FRemittancePay : Boolean;
      FNCRCreate : Boolean;
      FNCRChange : Boolean;
      FNCRClose : Boolean;
      FNCRCostOrder : Boolean;
      FNCRREOPEN : Boolean;
      FNCRREPORT : Boolean;
      FNCRSupervisor : Boolean;
      FCAllLoads : Boolean;
      FCUnAllLoads : Boolean;
      FSAllLoads : Boolean;
      FSUnAllLoads : Boolean;
      FStockPriceC : Boolean;
      FStockPriceO : Boolean;
      FMaintenanceSupp : Boolean;
      FShowLoadSubRate : Boolean;
      FShowLoadClientRate : Boolean;
      FTripScheduling : Boolean;
      FLoadconPrintRate : Boolean;
      FLoadCMI : Boolean;
      FOweriteRecDate : Boolean;
      FUnPayDiesel : Boolean;
      FGraphL1 : Boolean;
      FGraphL2 : Boolean;
      FGraphL3 : Boolean;
      FGraphL4 : Boolean;
      FGraphL5 : Boolean;
      FGraphL6 : Boolean;
      FGraphL7 : Boolean;
      FDieselPayment : Boolean;
      FTollSystem : Boolean;
      FTollRep : Boolean;
      FManRepSA : Boolean;
      FManRepVSA : Boolean;
      FManRepSSA : Boolean;
      FTollProcessing : Boolean;
      FNCRassessor : Boolean;
      FManRepVat : Boolean;
      FShowEmpRate : Boolean;
      FNCRSignOff : Boolean;
      FNCRGIT : Boolean;
      FNCRGAT : Boolean;
      FNCRGNT : Boolean;
      FNCRGIC : Boolean;
      FNCRGAC : Boolean;
      FNCRGNC : Boolean;
      FNCRGT5C : Boolean;
      FNCRGT5D : Boolean;
      FNCRGT5V : Boolean;
      FSecureCN : Boolean;
      FFuelSupp : Boolean;
      FWashbayDepot : Boolean;
      FWashbayProcess : Boolean;
      FAllowManRep : Boolean;
      FSuppCN : Boolean;
      FGoodsRepair : Boolean;
      FEmpClientReq : Boolean;
      FEmpCompReq : Boolean;
      FMiscTrans : Boolean;
      FMiscInv : Boolean;
      FMiscCN : Boolean;
      FSubCPay : Boolean;
      FSuppPay : Boolean;
      FDieselPayments : Boolean;
      FSupplierPayments : Boolean;
      FSupplierAll : Boolean;
      FReconLoads : Boolean;
      FOpenTrip : Boolean;
      FLinkedLoadInv : Boolean;
      FGetClientLoads : Boolean;
      FApproveSubInvoices : Boolean;
      FSendElecInvoices : Boolean;
      FLoadPlanningMain : Boolean;
      FLoadPlanning : Boolean;
      FPlanningSchedule : Boolean;
      FClosePlanning : Boolean;
      FContractOrders : Boolean;
      FProFormaInv : Boolean;
      FLoadDebitnote : Boolean;
      FVehgroups :Boolean;
      FAssetFinJournal : Boolean;
      FEmpPlanner : Boolean;
      FSubAccount : Boolean;
      FSuppRemit : Boolean;
      FAllRemitPay : Boolean;
      FUpfrontDiesel : Boolean;
      FUpfrontMaint : Boolean;
      FSuppReports : Boolean;
      FClientRep : Boolean;
      FFuelbulkorder : Boolean;
      FFuelDebit : Boolean;
      FOwnBulk : Boolean;
      FWashReport : Boolean;
      FWashDebit : Boolean;
      FWashCredit : Boolean;
      FCaptureFines : Boolean;
      FFineReport : Boolean;
      FAartoSched : Boolean;
      FMisccustinv : Boolean;
      FMisccustcred: Boolean;
      FAssetBal : Boolean;
      FVehCost : Boolean;
      FVehAssetView : Boolean;
      FUpgradeDatabase : Boolean;
      FChangeCancelLoads : Boolean;
      FMaintRPInv : Boolean;
      FMaintRPCN : Boolean;
      FRevSupp : Boolean;
      FRevCust : Boolean;
      FAllowLoadCutOff : Boolean;
      FAllowDieselCutOff : Boolean;
      FOverrideSubTons : Boolean;
      FSubsMultiInvoice : Boolean;
      FFleetInfoScreen : Boolean;
      FViewInvoiceScreen : Boolean;
      FSubsSupervisor : Boolean;
      FOwnFleetSupervisor : Boolean;
    public
      property Users: Boolean read FUsers write FUsers;
      property DieselSystem: Boolean read FDieselSystem write FDieselSystem;
      property DieselOrder: Boolean read FDieselOrder write FDieselOrder;
      property DieselInv: Boolean read FDieselInv write FDieselInv;
      property DieselDepots: Boolean read FDieselDepots write FDieselDepots;
      property DieselPrice: Boolean read FDieselPrice write FDieselPrice;
      property DieselPriceC: Boolean read FDieselPriceC write FDieselPriceC;
      property SubContractors: Boolean read FSubContractors write FSubContractors;
      property DieselReports: Boolean read FDieselReports write FDieselReports;
      property Driversys: Boolean read FDriversys write FDriversys;
      property VehicleSys: Boolean read FVehicleSys write FVehicleSys;
      property HSEReports: Boolean read FHSEReports write FHSEReports;
      property OpsReports: Boolean read FOpsReports write FOpsReports;
      property DieselPay: Boolean read FDieselPay write FDieselPay;
      property loadconsystem : Boolean read Floadconsystem  write Floadconsystem ;
      property Washbay : Boolean read FWashbay  write FWashbay ;
      property FullLoadCon : Boolean read FFullLoadCon  write FFullLoadCon ;
      property LoadConInvoice : Boolean read FLoadConInvoice  write FLoadConInvoice ;
      property Drivers : Boolean read FDrivers  write FDrivers ;
      property DriverReports : Boolean read FDriverReports  write FDriverReports ;
      property Publicholidays : Boolean read FPublicholidays  write FPublicholidays ;
      property DriverHours : Boolean read FDriverHours  write FDriverHours ;
      property ValidateHours : Boolean read FValidateHours  write FValidateHours ;
      property ConfirmHours : Boolean read FConfirmHours  write FConfirmHours ;
      property ClientActive : Boolean read FClientActive  write FClientActive ;
      property Contracts : Boolean read FContracts  write FContracts ;
      property LoadNonC : Boolean read FLoadNonC  write FLoadNonC ;
      property LoadC : Boolean read FLoadC  write FLoadC ;
      property CancelLoad : Boolean read FCancelLoad  write FCancelLoad ;
      property Client : Boolean read FClient  write FClient ;
      property CreateClient : Boolean read FCreateClient  write FCreateClient ;
      property SystemSetup : Boolean read FSystemSetup  write FSystemSetup ;
      property ControllFinPeriods : Boolean read FControllFinPeriods  write FControllFinPeriods ;
      property FineSystem : Boolean read FFineSystem  write FFineSystem ;
      property MaintenanceSystem : Boolean read FMaintenanceSystem  write FMaintenanceSystem ;
      property NonConformance : Boolean read FNonConformance  write FNonConformance ;
      property VehicleMain : Boolean read FVehicleMain  write FVehicleMain ;
      property Dailychecklist : Boolean read FDailychecklist  write FDailychecklist ;
      property AxleMassConfig : Boolean read FAxleMassConfig  write FAxleMassConfig ;
      property Vehicleunitconfig : Boolean read FVehicleunitconfig  write FVehicleunitconfig ;
      property Combinationconfig : Boolean read FCombinationconfig  write FCombinationconfig ;
      property VehicleReports : Boolean read FVehicleReports  write FVehicleReports ;
      property Vehiclejobcards : Boolean read FVehiclejobcards  write FVehiclejobcards ;
      property EmpYearsWeekDays : Boolean read FEmpYearsWeekDays  write FEmpYearsWeekDays ;
      property OverspeedingSystem : Boolean read FOverspeedingSystem  write FOverspeedingSystem ;
      property EmpCounselling : Boolean read FEmpCounselling  write FEmpCounselling ;
      property EmpWarnings : Boolean read FEmpWarnings  write FEmpWarnings ;
      property EmpBriefing : Boolean read FEmpBriefing  write FEmpBriefing ;
      property EmpPPE : Boolean read FEmpPPE  write FEmpPPE ;
      property Loadcons : Boolean read FLoadcons  write FLoadcons ;
      property LCCreditNoteSystem : Boolean read FLCCreditNoteSystem  write FLCCreditNoteSystem ;
      property LCAllocateInv : Boolean read FLCAllocateInv  write FLCAllocateInv ;
      property LCPaymentSystem : Boolean read FLCPaymentSystem  write FLCPaymentSystem ;
      property LCReports : Boolean read FLCReports  write FLCReports ;
      property LCUpdateInvLoads : Boolean read FLCUpdateInvLoads  write FLCUpdateInvLoads ;
      property ClientPayReceive : Boolean read FClientPayReceive  write FClientPayReceive ;
      property ClientUnAllPay : Boolean read FClientUnAllPay  write FClientUnAllPay ;
      property Clientsites : Boolean read FClientsites  write FClientsites ;
      property ClientWrietOff : Boolean read FClientWrietOff  write FClientWrietOff ;
      property SubRemittance : Boolean read FSubRemittance  write FSubRemittance ;
      property SubPayment : Boolean read FSubPayment  write FSubPayment ;
      property SubUnAllPay : Boolean read FSubUnAllPay  write FSubUnAllPay ;
      property SubAllPay : Boolean read FSubAllPay  write FSubAllPay ;
      property SubWriteOff : Boolean read FSubWriteOff  write FSubWriteOff ;
      property LCSLCN : Boolean read FLCSLCN  write FLCSLCN ;
      property LCMLCN : Boolean read FLCMLCN  write FLCMLCN ;
      property FuelAttendants : Boolean read FFuelAttendants  write FFuelAttendants ;
      property FuelDepots : Boolean read FFuelDepots  write FFuelDepots ;
      property FuelControlSheets : Boolean read FFuelControlSheets  write FFuelControlSheets ;
      property FuelMonthEnd : Boolean read FFuelMonthEnd  write FFuelMonthEnd ;
      property FuelCDN : Boolean read FFuelCDN  write FFuelCDN ;
      property FuelUpdateInv : Boolean read FFuelUpdateInv  write FFuelUpdateInv ;
      property FuelTankSetup : Boolean read FFuelTankSetup  write FFuelTankSetup ;
      property FuelPriceChange : Boolean read FFuelPriceChange  write FFuelPriceChange ;
      property FuelSuspendDepots : Boolean read FFuelSuspendDepots  write FFuelSuspendDepots ;
      property Vehcategories : Boolean read FVehcategories  write FVehcategories ;
      property Vehservicetypes : Boolean read FVehservicetypes  write FVehservicetypes ;
      property Vehservicehistory : Boolean read FVehservicehistory  write FVehservicehistory ;
      property VehMoveHistory : Boolean read FVehMoveHistory  write FVehMoveHistory ;
      property Compsites : Boolean read FCompsites  write FCompsites ;
      property AutoEmail : Boolean read FAutoEmail  write FAutoEmail ;
      property RegAccess : Boolean read FRegAccess  write FRegAccess ;
      property pastelexport : Boolean read Fpastelexport  write Fpastelexport ;
      property InvoiceLitres : Boolean read FInvoiceLitres  write FInvoiceLitres ;
      property ExportToExcel : Boolean read FExportToExcel  write FExportToExcel ;
      property RemContPrice : Boolean read FRemContPrice  write FRemContPrice ;
      property OpenContPrice : Boolean read FOpenContPrice  write FOpenContPrice ;
      property RemDieselPrice : Boolean read FRemDieselPrice  write FRemDieselPrice ;
      property OpenDieselPrice : Boolean read FOpenDieselPrice  write FOpenDieselPrice ;
      property Warehouse : Boolean read FWarehouse  write FWarehouse ;
      property Locations : Boolean read FLocations  write FLocations ;
      property Categories : Boolean read FCategories  write FCategories ;
      property Waranties : Boolean read FWaranties  write FWaranties ;
      property StockInfo : Boolean read FStockInfo  write FStockInfo ;
      property StkSuppliers : Boolean read FStkSuppliers  write FStkSuppliers ;
      property JCstock : Boolean read FJCstock  write FJCstock ;
      property JCTyres : Boolean read FJCTyres  write FJCTyres ;
      property PRstock : Boolean read FPRstock  write FPRstock ;
      property PRTyres : Boolean read FPRTyres  write FPRTyres ;
      property POstock : Boolean read FPOstock  write FPOstock ;
      property POTyres : Boolean read FPOTyres  write FPOTyres ;
      property POAstock : Boolean read FPOAstock  write FPOAstock ;
      property POATyres : Boolean read FPOATyres  write FPOATyres ;
      property PDstock : Boolean read FPDstock  write FPDstock ;
      property PDTyres : Boolean read FPDTyres  write FPDTyres ;
      property SuppInv : Boolean read FSuppInv  write FSuppInv ;
      property StockTake : Boolean read FStockTake  write FStockTake ;
      property Stocktransfer : Boolean read FStocktransfer  write FStocktransfer ;
      property StockRep : Boolean read FStockRep  write FStockRep ;
      property CaptureMultiLoads : Boolean read FCaptureMultiLoads  write FCaptureMultiLoads ;
      property LoadSupervisor : Boolean read FLoadSupervisor  write FLoadSupervisor ;
      property DieselSupervisor : Boolean read FDieselSupervisor  write FDieselSupervisor ;
      property RemittancePay : Boolean read FRemittancePay  write FRemittancePay ;
      property NCRCreate : Boolean read FNCRCreate  write FNCRCreate ;
      property NCRChange : Boolean read FNCRChange  write FNCRChange ;
      property NCRClose : Boolean read FNCRClose  write FNCRClose ;
      property NCRCostOrder : Boolean read FNCRCostOrder  write FNCRCostOrder ;
      property NCRREOPEN : Boolean read FNCRREOPEN  write FNCRREOPEN ;
      property NCRREPORT : Boolean read FNCRREPORT  write FNCRREPORT ;
      property NCRSupervisor : Boolean read FNCRSupervisor  write FNCRSupervisor ;
      property CAllLoads : Boolean read FCAllLoads  write FCAllLoads ;
      property CUnAllLoads : Boolean read FCUnAllLoads  write FCUnAllLoads ;
      property SAllLoads : Boolean read FSAllLoads  write FSAllLoads ;
      property SUnAllLoads : Boolean read FSUnAllLoads  write FSUnAllLoads ;
      property StockPriceC : Boolean read FStockPriceC  write FStockPriceC ;
      property StockPriceO : Boolean read FStockPriceO  write FStockPriceO ;
      property MaintenanceSupp : Boolean read FMaintenanceSupp  write FMaintenanceSupp ;
      property ShowLoadSubRate : Boolean read FShowLoadSubRate  write FShowLoadSubRate ;
      property ShowLoadClientRate : Boolean read FShowLoadClientRate  write FShowLoadClientRate ;
      property TripScheduling : Boolean read FTripScheduling  write FTripScheduling ;
      property LoadconPrintRate : Boolean read FLoadconPrintRate  write FLoadconPrintRate ;
      property LoadCMI : Boolean read FLoadCMI  write FLoadCMI ;
      property OweriteRecDate : Boolean read FOweriteRecDate  write FOweriteRecDate ;
      property UnPayDiesel : Boolean read FUnPayDiesel  write FUnPayDiesel ;
      property GraphL1 : Boolean read FGraphL1  write FGraphL1 ;
      property GraphL2 : Boolean read FGraphL2  write FGraphL2 ;
      property GraphL3 : Boolean read FGraphL3  write FGraphL3 ;
      property GraphL4 : Boolean read FGraphL4  write FGraphL4 ;
      property GraphL5 : Boolean read FGraphL5  write FGraphL5 ;
      property GraphL6 : Boolean read FGraphL6  write FGraphL6 ;
      property GraphL7 : Boolean read FGraphL7  write FGraphL7 ;
      property DieselPayment : Boolean read FDieselPayment  write FDieselPayment ;
      property TollSystem : Boolean read FTollSystem  write FTollSystem ;
      property TollRep : Boolean read FTollRep  write FTollRep ;
      property ManRepSA : Boolean read FManRepSA  write FManRepSA ;
      property ManRepVSA : Boolean read FManRepVSA  write FManRepVSA ;
      property ManRepSSA : Boolean read FManRepSSA  write FManRepSSA ;
      property TollProcessing : Boolean read FTollProcessing  write FTollProcessing ;
      property NCRassessor : Boolean read FNCRassessor  write FNCRassessor ;
      property ManRepVat : Boolean read FManRepVat  write FManRepVat ;
      property ShowEmpRate : Boolean read FShowEmpRate  write FShowEmpRate ;
      property NCRSignOff : Boolean read FNCRSignOff  write FNCRSignOff ;
      property NCRGIT : Boolean read FNCRGIT  write FNCRGIT ;
      property NCRGAT : Boolean read FNCRGAT  write FNCRGAT ;
      property NCRGNT : Boolean read FNCRGNT  write FNCRGNT ;
      property NCRGIC : Boolean read FNCRGIC  write FNCRGIC ;
      property NCRGAC : Boolean read FNCRGAC  write FNCRGAC ;
      property NCRGNC : Boolean read FNCRGNC  write FNCRGNC ;
      property NCRGT5C : Boolean read FNCRGT5C  write FNCRGT5C ;
      property NCRGT5D : Boolean read FNCRGT5D  write FNCRGT5D ;
      property NCRGT5V : Boolean read FNCRGT5V  write FNCRGT5V ;
      property SecureCN : Boolean read FSecureCN  write FSecureCN ;
      property FuelSupp : Boolean read FFuelSupp  write FFuelSupp ;
      property WashbayDepot : Boolean read FWashbayDepot  write FWashbayDepot ;
      property WashbayProcess : Boolean read FWashbayProcess  write FWashbayProcess ;
      property AllowManRep : Boolean read FAllowManRep  write FAllowManRep ;
      property SuppCN : Boolean read FSuppCN  write FSuppCN ;
      property GoodsRepair : Boolean read FGoodsRepair  write FGoodsRepair ;
      property EmpClientReq : Boolean read FEmpClientReq  write FEmpClientReq ;
      property EmpCompReq : Boolean read FEmpCompReq  write FEmpCompReq ;
      property MiscTrans : Boolean read FMiscTrans  write FMiscTrans ;
      property MiscInv : Boolean read FMiscInv  write FMiscInv ;
      property MiscCN : Boolean read FMiscCN  write FMiscCN ;
      property SubCPay : Boolean read FSubCPay  write FSubCPay ;
      property SuppPay : Boolean read FSuppPay  write FSuppPay ;
      property DieselPayments : Boolean read FDieselPayments  write FDieselPayments ;
      property SupplierPayments : Boolean read FSupplierPayments  write FSupplierPayments ;
      property SupplierAll : Boolean read FSupplierAll  write FSupplierAll ;
      property ReconLoads : Boolean read FReconLoads  write FReconLoads ;
      property OpenTrip : Boolean read FOpenTrip  write FOpenTrip ;
      property LinkedLoadInv : Boolean read FLinkedLoadInv  write FLinkedLoadInv ;
      property GetClientLoads : Boolean read FGetClientLoads  write FGetClientLoads ;
      property ApproveSubInvoices : Boolean read FApproveSubInvoices  write FApproveSubInvoices ;
      property SendElecInvoices : Boolean read FSendElecInvoices  write FSendElecInvoices ;
      property LoadPlanningMain : Boolean read FLoadPlanningMain  write FLoadPlanningMain ;
      property LoadPlanning : Boolean read FLoadPlanning  write FLoadPlanning ;
      property PlanningSchedule : Boolean read FPlanningSchedule  write FPlanningSchedule ;
      property ClosePlanning : Boolean read FClosePlanning  write FClosePlanning ;
      property ContractOrders : Boolean read FContractOrders  write FContractOrders ;
      property ProFormaInv : Boolean read FProFormaInv  write FProFormaInv ;
      property LoadDebitnote : Boolean read FLoadDebitnote  write FLoadDebitnote ;
      property Vehgroups :Boolean read FVehgroups write FVehgroups;
      property AssetFinJournal : Boolean read FAssetFinJournal  write FAssetFinJournal ;
      property EmpPlanner : Boolean read FEmpPlanner  write FEmpPlanner ;
      property SubAccount : Boolean read FSubAccount  write FSubAccount ;
      property SuppRemit : Boolean read FSuppRemit  write FSuppRemit ;
      property AllRemitPay : Boolean read FAllRemitPay  write FAllRemitPay ;
      property UpfrontDiesel : Boolean read FUpfrontDiesel  write FUpfrontDiesel ;
      property UpfrontMaint : Boolean read FUpfrontMaint  write FUpfrontMaint ;
      property SuppReports : Boolean read FSuppReports  write FSuppReports ;
      property ClientRep : Boolean read FClientRep  write FClientRep ;
      property Fuelbulkorder : Boolean read FFuelbulkorder  write FFuelbulkorder ;
      property FuelDebit : Boolean read FFuelDebit  write FFuelDebit ;
      property OwnBulk : Boolean read FOwnBulk  write FOwnBulk ;
      property WashReport : Boolean read FWashReport  write FWashReport ;
      property WashDebit : Boolean read FWashDebit  write FWashDebit ;
      property WashCredit : Boolean read FWashCredit  write FWashCredit ;
      property CaptureFines : Boolean read FCaptureFines  write FCaptureFines ;
      property FineReport : Boolean read FFineReport  write FFineReport ;
      property AartoSched : Boolean read FAartoSched  write FAartoSched ;
      property Misccustinv : Boolean read FMisccustinv  write FMisccustinv ;
      property Misccustcred: Boolean read FMisccustcred write FMisccustcred;
      property AssetBal : Boolean read FAssetBal  write FAssetBal ;
      property VehCost : Boolean read FVehCost  write FVehCost ;
      property VehAssetView : Boolean read FVehAssetView  write FVehAssetView ;
      property UpgradeDatabase : Boolean read FUpgradeDatabase  write FUpgradeDatabase ;
      property ChangeCancelLoads : Boolean read FChangeCancelLoads  write FChangeCancelLoads ;
      property MaintRPInv : Boolean read FMaintRPInv  write FMaintRPInv ;
      property MaintRPCN : Boolean read FMaintRPCN  write FMaintRPCN ;
      property RevSupp : Boolean read FRevSupp  write FRevSupp ;
      property RevCust : Boolean read FRevCust  write FRevCust ;
      property AllowLoadCutOff : Boolean read FAllowLoadCutOff  write FAllowLoadCutOff ;
      property AllowDieselCutOff : Boolean read FAllowDieselCutOff  write FAllowDieselCutOff ;
      property OverrideSubTons : Boolean read FOverrideSubTons  write FOverrideSubTons ;
      property SubsMultiInvoice : Boolean read FSubsMultiInvoice  write FSubsMultiInvoice ;
      property FleetInfoScreen : Boolean read FFleetInfoScreen  write FFleetInfoScreen ;
      property ViewInvoiceScreen : Boolean read FViewInvoiceScreen  write FViewInvoiceScreen ;
      property SubsSupervisor : Boolean read FSubsSupervisor write FSubsSupervisor;
      property OwnFleetSupervisor : Boolean read FOwnFleetSupervisor write FOwnFleetSupervisor;
  End;

  TDashRevenue = Class
    private
      FLoadSystem : String;
      FLoadValue : Currency;
      FInvoiced : Boolean;
      FOwnFleet : Boolean;
    public
      property LoadSystem : String read FLoadSystem write FLoadSystem;
      property LoadValue : Currency read FLoadValue write FLoadValue;
      property Invoiced : Boolean read FInvoiced write FInvoiced;
      property OwnFleet : Boolean read FOwnFleet write FOwnFleet;
  End;

  TCustomerRevenue = Class
    private
      FCode : String;
      FName : String;
      FTotalCount : Integer;
      FTotal : Real;
      FInvoiced : Real;
      FNotInvoiced : Real;
    public
      property Code : String read FCode write FCode;
      property Name : String read FName write FName;
      property TotalCount : Integer read FTotalCount write FTotalCount;
      property Total : Real read FTotal write FTotal;
      property Invoiced : Real read FInvoiced write FInvoiced;
      property NotInvoiced : Real read FNotInvoiced write FNotInvoiced;
  End;

  TCustomerContractRevenue = Class
    private
      FCode : Integer;
      FName : String;
      FTotalCount : Integer;
      FTotal : Real;
      FInvoiced : Real;
      FNotInvoiced : Real;
    public
      property Code : Integer read FCode write FCode;
      property Name : String read FName write FName;
      property TotalCount : Integer read FTotalCount write FTotalCount;
      property Total : Real read FTotal write FTotal;
      property Invoiced : Real read FInvoiced write FInvoiced;
      property NotInvoiced : Real read FNotInvoiced write FNotInvoiced;
    public
  End;

  TOwnFleetBudget = Class
    private
      FDescription : String;
      FYearNo : Integer;
      FMonthNo : Integer;
      FRevenueTotal : Real;
      FSurplusTotal : Real;
      FCostCode : Integer;
    public
      property Description : String read FDescription write FDescription;
      property YearNo : Integer read FYearNo write FYearNo;
      property MonthNo : Integer read FMonthNo write FMonthNo;
      property RevenueTotal : Real read FRevenueTotal write FRevenueTotal;
      property SurplusTotal : Real read FSurplusTotal write FSurplusTotal;
      property CostCode : Integer read FCostCode write FCostCode;
  End;

  TDashYears = class
    private
      FYear : Integer;
      FSelected : Boolean;
    public
      property Year : Integer read FYear write FYear;
      property Selected : Boolean read FSelected write FSelected;
  end;

  TDashMonths = class
    private
      FMonth : Integer;
      FMonthName : String;
      FSelected : Boolean;
    public
      property Month : Integer read FMonth write FMonth;
      property MonthName : String read FMonthName write FMonthName;
      property Selected : Boolean read FSelected write FSelected;
  end;

  TDashSysTypes = class
    private
      FSysType : Integer;
      FDescription : String;
      FSelected : Boolean;
    public
      property SysType : Integer read FSysType write FSysType;
      property Description : String read FDescription write FDescription;
      property Selected : Boolean read FSelected write FSelected;
  end;

  TDashJobCostDesc = class
    private
      FCost : Integer;
      FDescription : String;
      FSelected : Boolean;
    public
      property Cost : Integer read FCost write FCost;
      property Description : String read FDescription write FDescription;
      property Selected : Boolean read FSelected write FSelected;
  end;

  TDashRegFleet = class
    private
      FReg : String;
      FFleetNo : String;
      FFleetType : String;
      FSelected : Boolean;
      FHPriKey : Integer;
      FTPriKey : Integer;
      FCrNumber : String;
      FCrName : string;

    public
      property Reg : String read FReg write FReg;
      property FleetNo : String read FFleetNo write FFleetNo;
      property FleetType : String read FFleetType write FFleetType;
      property Selected : Boolean read FSelected write FSelected;
      property HPriKey : Integer read FHPriKey write FHPriKey;
      property TPriKey : Integer read FTPriKey write FTPriKey;
      property CrNumber : String read FCrNumber write FCrNumber;
      property CrName : String read FCrName write FCrName;
  end;

  TDashJobcardTypeTotals = class
    private
      FMaintenanceCost : String;
      FTyreCost : String;
      FWashCost : String;
      FInsuranceCost : String;
      FOtherCost : String;
      FTotalCost : String;
      FCapexCost : String;
      FUnallCost : String;
      FMaintenanceCPK : String;
      FTyreCPK : String;
      FWashCPK : String;
      FInsuranceCPK : String;
      FOtherCPK : String;
      FTotalCPK : String;
      FCapexCPK : String;
      FUnallCPK : String;

    public
      property MaintenanceCost : String read FMaintenanceCost write FMaintenanceCost;
      property TyreCost : String read FTyreCost write FTyreCost;
      property WashCost : String read FWashCost write FWashCost;
      property InsuranceCost : String read FInsuranceCost write FInsuranceCost;
      property OtherCost : String read FOtherCost write FOtherCost;
      property TotalCost : String read FTotalCost write FTotalCost;
      property CapexCost : String read FCapexCost write FCapexCost;
      property UnallCost : String read FUnallCost write FUnallCost;
      property MaintenanceCPK : String read FMaintenanceCPK write FMaintenanceCPK;
      property TyreCPK : String read FTyreCPK write FTyreCPK;
      property WashCPK : String read FWashCPK write FWashCPK;
      property InsuranceCPK : String read FInsuranceCPK write FInsuranceCPK;
      property OtherCPK : String read FOtherCPK write FOtherCPK;
      property TotalCPK : String read FTotalCPK write FTotalCPK;
      property CapexCPK : String read FCapexCPK write FCapexCPK;
      property UnallCPK : String read FUnallCPK write FUnallCPK;
  end;

  TDashJobcardTypeDetail = class
    private
      FJobcardNo : Integer;
      FStockDescription: String;
      FTotalExcl : String;
      FGlCode : String;
      FReason : String;
      FCategory : String;
      FRepMain : String;
      FCostDescription : String;
      FTRegNo : String;
      FTFleetNo : String;
      FOrderNo : String;
      FJobDate : TDate;
      FReferenceNo : String;
      FVehtype : String;
      FJobType : String;
      FSupplier : String;

    public
      property JobcardNo : Integer read FJobcardNo write FJobcardNo;
      property StockDescription : String read FStockDescription write FStockDescription;
      property TotalExcl : String read FTotalExcl write FTotalExcl;
      property GlCode : String read FGlCode write FGlCode;
      property Reason : String read FReason write FReason;
      property Category : String read FCategory write FCategory;
      property RepMain : String read FRepMain write FRepMain;
      property CostDescription : String read FCostDescription write FCostDescription;
      property TRegNo : String read FTRegNo write FTRegNo;
      property TFleetNo : String read FTFleetNo write FTFleetNo;
      property OrderNo : String read FOrderNo write FOrderNo;
      property JobDate : TDate read FJobDate write FJobDate;
      property ReferenceNo : String read FReferenceNo write FReferenceNo;
      property Vehtype : String read FVehtype write FVehtype;
      property JobType : String read FJobType write FJobType;
      property Supplier : String read FSupplier write FSupplier;


  end;

  TRepDashJobcardTypeDetail = class
    private
      FJobcardNo : Integer;
      FStockDescription: String;
      FTotalExcl : String;
      FGlCode : String;
      FReason : String;
      FCategory : String;
      FRepMain : String;
      FCostDescription : String;
      FTRegNo : String;
      FTFleetNo : String;
      FOrderNo : String;
      FJobDate : TDate;
      FReferenceNo : String;
      FVehtype : String;
      FJobType : String;
      FSupplier : String;
      FReportType : String;


    public
      property JobcardNo : Integer read FJobcardNo write FJobcardNo;
      property StockDescription : String read FStockDescription write FStockDescription;
      property TotalExcl : String read FTotalExcl write FTotalExcl;
      property GlCode : String read FGlCode write FGlCode;
      property Reason : String read FReason write FReason;
      property Category : String read FCategory write FCategory;
      property RepMain : String read FRepMain write FRepMain;
      property CostDescription : String read FCostDescription write FCostDescription;
      property TRegNo : String read FTRegNo write FTRegNo;
      property TFleetNo : String read FTFleetNo write FTFleetNo;
      property OrderNo : String read FOrderNo write FOrderNo;
      property JobDate : TDate read FJobDate write FJobDate;
      property ReferenceNo : String read FReferenceNo write FReferenceNo;
      property Vehtype : String read FVehtype write FVehtype;
      property JobType : String read FJobType write FJobType;
      property Supplier : String read FSupplier write FSupplier;
      property ReportType : String read FReportType write FReportType;


  end;

  TGetContracts = class
    private
      FContractNo : Integer;
      FContractName : String;
      FDebCode : String;
      FDeb_Name : String;

    public
      property ContractNo : Integer read FContractNo write FContractNo;
      property ContractName : String read FContractName write FContractName;
      property DebCode : String read FDebCode write FDebCode;
      property Deb_Name : String read FDeb_Name write FDeb_Name;
  end;

  TDashLoadconsTotals = class
    private
      FLoadsName : String;
      FLoadsC : Integer;
      FLoadsR : Real;
      FLoadsPos : Integer;
      FLoadsIName : String;
      FLoadsIC : Integer;
      FLoadsIR : Real;
      FLoadsIPos : Integer;
      FLoadsINRName : String;
      FLoadsINRC : Integer;
      FLoadsINRR : Real;
      FLoadsINRPos : Integer;
      FLoadsNIName : String;
      FLoadsNIC : Integer;
      FLoadsNIR : Real;
      FLoadsNIPos : Integer;
      FLoadsNRName : String;
      FLoadsNRC : Integer;
      FLoadsNRR : Real;
      FLoadsNRPos : Integer;
    public
      property LoadsName : String read FLoadsName write FLoadsName;
      property LoadsC : Integer read FLoadsC write FLoadsC;
      property LoadsR : Real read FLoadsR write FLoadsR;
      property LoadsPos : Integer read FLoadsPos write FLoadsPos;
      property LoadsIName : String read FLoadsIName write FLoadsIName;
      property LoadsIC : Integer read FLoadsIC write FLoadsIC;
      property LoadsIR : Real read FLoadsIR write FLoadsIR;
      property LoadsIPos : Integer read FLoadsIPos write FLoadsIPos;
      property LoadsINRName : String read FLoadsINRName write FLoadsINRName;
      property LoadsINRC : Integer read FLoadsINRC write FLoadsINRC;
      property LoadsINRR : Real read FLoadsINRR write FLoadsINRR;
      property LoadsINRPos : Integer read FLoadsINRPos write FLoadsINRPos;
      property LoadsNIName : String read FLoadsNIName write FLoadsNIName;
      property LoadsNIC : Integer read FLoadsNIC write FLoadsNIC;
      property LoadsNIR : Real read FLoadsNIR write FLoadsNIR;
      property LoadsNIPos : Integer read FLoadsNIPos write FLoadsNIPos;
      property LoadsNRName : String read FLoadsNRName write FLoadsNRName;
      property LoadsNRC : Integer read FLoadsNRC write FLoadsNRC;
      property LoadsNRR : Real read FLoadsNRR write FLoadsNRR;
      property LoadsNRPos : Integer read FLoadsNRPos write FLoadsNRPos;
  end;

  TDashLoadconsController = class
    private
      FConKey : String;
      FController : String;
      FTotalLoads : Integer;
      FRevenue : Real;
      FOver10Days : Integer;
      FOver5Days : Integer;
    public
      property ConKey : String read FConKey write FConKey;
      property Controller : String read FController write FController;
      property TotalLoads : Integer read FTotalLoads write FTotalLoads;
      property Revenue : Real read FRevenue write FRevenue;
      property Over10Days : Integer read FOver10Days write FOver10Days;
      property Over5Days : Integer read FOver5Days write FOver5Days;
  end;

  TDashLoadconsControllerDetail = class
    private
      FConKey : String;
      FController : String;
      FLoadconNo : Integer;
      FRegNo : String;
      FLoadeddate : TDateTime;
      FContractNo : Integer;
      FContractName : String;
      FRevenue : Real;
    public
      property ConKey : String read FConKey write FConKey;
      property Controller : String read FController write FController;
      property LoadconNo : Integer read FLoadconNo write FLoadconNo;
      property RegNo : String read FRegNo write FRegNo;
      property Loadeddate : TDateTime read FLoadeddate write FLoadeddate;
      property ContractNo : Integer read FContractNo write FContractNo;
      property ContractName : String read FContractName write FContractName;
      property Revenue : Real read FRevenue write FRevenue;
  end;

  TDashLoadsNotInvoicedDetail = class
    private
      FDebName : String;
      FContractName : String;
      FDebCode : String;
      FContractNo : Integer;
      FTotalLoads : Integer;
      FLess10Days : Integer;
      FOver10Days : Integer;
      FOver20Days : Integer;
    public
      property DebName : String read FDebName write FDebName;
      property ContractName : String read FContractName write FContractName;
      property DebCode : String read FDebCode write FDebCode;
      property ContractNo : Integer read FContractNo write FContractNo;
      property TotalLoads : Integer read FTotalLoads write FTotalLoads;
      property Less10Days : Integer read FLess10Days write FLess10Days;
      property Over10Days : Integer read FOver10Days write FOver10Days;
      property Over20Days : Integer read FOver20Days write FOver20Days;
  end;

  TDashLoadsNotInvoicedDetailTracking = class
    private
      FLoadConNo : Integer;
      FLoadedDate : TDateTime;
      FReceivedDate : TDateTime;
      FScannedDate : TDateTime;
      FRegNo : String;
      FController : String;
    public
      property LoadConNo : Integer read FLoadConNo write FLoadConNo;
      property LoadedDate : TDateTime read FLoadedDate write FLoadedDate;
      property ReceivedDate : TDateTime read FReceivedDate write FReceivedDate;
      property ScannedDate : TDateTime read FScannedDate write FScannedDate;
      property RegNo : String read FRegNo write FRegNo;
      property Controller : String read FController write FController;
  end;

  TDashLoadsNotInvoicedDetailTrackingDetails = class
    private
      FAutoNo : Integer;
      FLoadConNo : Integer;
      FForUserCode : String;
      FScanDateTime : TDateTime;
      FScanType : String;
      FForUserName : String;
      FScanUser : String;
      FScanName : String;
    public
      property AutoNo : Integer read FAutoNo write FAutoNo;
      property LoadConNo : Integer read FLoadConNo write FLoadConNo;
      property ForUserCode : String read FForUserCode write FForUserCode;
      property ScanDateTime : TDateTime read FScanDateTime write FScanDateTime;
      property ScanType : String read FScanType write FScanType;
      property ForUserName : String read FForUserName write FForUserName;
      property ScanUser : String read FScanUser write FScanUser;
      property ScanName : String read FScanName write FScanName;
  end;

  {//Moved to Share.system.classes - TSysAutoMailView
  TAutoEmailSetup = class
    private
      FAutoMail_Auto : Integer;
      FSlnCode : String;
      FReportSystem  : Integer;
      FCompany : String;
      FPeriodNo : Integer;
      FPeriodType : Integer;
      FLastDate : TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotice : Boolean;
      FUserEmail : Boolean;
      FReportDesc : string;
      FPeriodTypeDesc : string;
      FCRName : string;
    public
      property AutoMail_Auto : Integer read FAutoMail_Auto write FAutoMail_Auto;
      property SLnCode : String read FSLNCODE write FSLNCODE;
      property ReportSystem  : Integer read FREPORTSYSTEM write FREPORTSYSTEM;
      property Company : String read FCOMPANY write FCOMPANY;
      property PeriodNo : Integer read FPERIODNO write FPERIODNO;
      property PeriodType : Integer read FPERIODTYPE write FPERIODTYPE;
      property LastDate : TDate read FLASTDATE write FLASTDATE;
      property NextDate : TDate read FNEXTDATE write FNEXTDATE;
      property ChangeDate : TDate read FCHANGEDATE write FCHANGEDATE;
      property UserNotice : Boolean read FUSERNOTICE write FUSERNOTICE;
      property UserEmail : Boolean read FUSEREMAIL write FUSEREMAIL;
      property ReportDesc : String read FReportDesc write FReportDesc;
      property PeriodTypeDesc : String read FPeriodTypeDesc write FPeriodTypeDesc;
      property CRName : String read Fcrname write Fcrname;
  end;}

  TPasswordMode = (pmLower, pmUpper, pmNumbers, pmExtra);
  TPasswordModes = set of TPasswordMode;

  function GeneratePassword(aLength: Integer; aModes: TPasswordModes): string;
  function GetRandomEmptyPos(const aStr: string): integer; inline;

implementation

function GetRandomEmptyPos(const aStr: string): integer; inline;
begin
  // find random empty position
  repeat
    Result := Random(Length(aStr)) + 1;
  until aStr[Result] = ' ';
end;

function GeneratePassword(aLength: Integer; aModes: TPasswordModes): string;
  const
    cLower   = 'abcdefghijklmnopqrstuvwxyz';
    cUpper   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    cNumbers = '0123456789';
    cExtra   = '_.#@%$';
  var
    i,vPos: integer;
    vMode: TPasswordMode;
begin
  if (aLength = 0) or (aModes = []) then Exit;
  //Randomize;

  // Prefill Result with empty spaces
  Result := StringOfChar(' ', aLength);

  // Add extra characters at random places
  for vMode in aModes do
  begin
    vPos := GetRandomEmptyPos(Result);
    case vMode of
      pmLower:    Result[vPos] := cLower[Random(Length(cLower)) + 1];
      pmUpper:    Result[vPos] := cUpper[Random(Length(cUpper)) + 1];
      pmNumbers:  Result[vPos] := cNumbers[Random(Length(cNumbers)) + 1];
      pmExtra:    Result[vPos] := cExtra[Random(Length(cExtra)) + 1];
    end;
  end;

  // Add random char on emtpy spaces
  for i := 1 to Length(Result) do
    if Result[i] = ' ' then
      Result[i] := String(cLower + cNumbers)[Random(Length(cLower) + Length(cNumbers)) + 1];
end;

{TLogin}

destructor TLogin.Destroy;
begin
  inherited;
end;

{TSubsFleetSummary}

destructor TSubsFleetSummary.Destroy;
begin
  inherited;
end;

{TSubsFleetLoadDetails}

destructor TSubsFleetLoadDetails.Destroy;
begin
  inherited;
end;

{TSubsFleetDieselDetails}

destructor TSubsFleetDieselDetails.Destroy;
begin
  inherited;
end;

{TDriverFleetLoads}
destructor TDriverFleetLoads.Destroy;
begin
  inherited;
end;


end.
